import React, { useState } from "react"
import { Card, CardBody, CardTitle } from "reactstrap"

import { useWallet } from "../libs/useMetaMaskWallet"
import { useToast } from "../hooks/toast"
import { formatAddress, blockchainExplorers } from "../utils"
import subdomains from "../constants/subdomains.json"
import NftCard from "../Components/NftCard/NftCard"
import CustomTooltip from "../Components/Tooltip"
import BreadCrumb from "../Components/BreadCrumb"
import { lootBoxType } from "./NFTSale/utils"

const TokenDetails = (props) => {
    const { subdomain, lootbox, nft, idx, breadCrumbTitle, contractAddress, chain, contractOwner, collectionSymbol } = props?.location?.state || {}

    const lootboxDetailsHeaderText = subdomains[subdomain]?.lootboxDetailsHeaderText
    const lootboxDetailsTxt1 = subdomains[subdomain]?.lootboxDetails?.[lootbox?.type || lootBoxType[lootbox?.name]]
    console.log("NFT", nft)

    const wallet = useWallet()
    const toast = useToast()

    const handleCopyClick = (text) => {
        navigator.clipboard.writeText(text.replace("×", "x"))
        toast.addSuccess(`${formatAddress(text)} copied to clipboard.`)
    }

    return (
        <div className="content token-detail-wrap">
            <BreadCrumb items={["NFT Sale", breadCrumbTitle]} links={["nftsale"]} />

            <Card>
                <CardBody>
                    <CardTitle className="h3">{"Token Details: " + nft?.name}</CardTitle>

                    <div className="token-details-txt">{lootboxDetailsTxt1}</div>

                    <div className={"left-right-wrap" + (lootbox?.opened ? " box-open" : "")}>
                        <div className="token-detail-left">
                            <div className="nft-card-wrap">
                                <NftCard
                                    nft={nft}
                                    idx={idx}
                                    subdomain={subdomain}
                                    key={idx}
                                    enableClickNFT={false} // if true, clicking on this component will load details page
                                    contractType="nftCollection"
                                />
                            </div>
                        </div>

                        <div className="token-detail-right">
                            <ul>
                                <li>
                                    <span className="detail-label">Contract Address</span>
                                    <span className="detail-val">
                                        {/* {formatAddress(contractAddress)} */}
                                        {contractAddress}
                                        <CustomTooltip title="Open in blockchain explorer" placement="bottom">
                                            <i
                                                className="bx bx-link-external"
                                                onClick={() => {
                                                    // open blockchain explorer in new tab
                                                    const url = `${blockchainExplorers[chain.toLowerCase()]}${contractAddress}`
                                                    window.open(url, "_blank", "noopener,noreferrer")
                                                }}
                                            />
                                        </CustomTooltip>
                                    </span>
                                </li>
                                <li>
                                    <span className="detail-label">Contract Owner</span>
                                    <span className="detail-val">
                                        {contractOwner}
                                        <CustomTooltip title="Copy Address" placement="bottom">
                                            <i className="bx bx-copy" onClick={() => handleCopyClick(contractOwner)} />
                                        </CustomTooltip>
                                    </span>
                                </li>
                                <li>
                                    <span className="detail-label">Blockchain</span> <span className="detail-val">{chain}</span>
                                </li>
                                <li>
                                    <span className="detail-label">Collection Symbol</span> <span className="detail-val">{collectionSymbol}</span>
                                </li>
                                <li>
                                    {/* TO DO: call method on contract to get current owner- hard coded to users wallet address for now */}
                                    <span className="detail-label">Token Owner</span>
                                    <span className="detail-val">
                                        {wallet?.account}
                                        <CustomTooltip title="Copy Address" placement="bottom">
                                            <i className="bx bx-copy" onClick={() => handleCopyClick(wallet?.account)} />
                                        </CustomTooltip>
                                    </span>
                                </li>
                                <li>
                                    <span className="detail-label">Token ID</span> <span className="detail-val">{nft?.tokenId}</span>
                                </li>
                                <li>
                                    <span className="detail-label">Metadata URI </span>
                                    <span className="detail-val metadata-uri">
                                        <a href={nft?.tokenURI} target="_blank">
                                            {nft?.tokenURI}
                                        </a>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default TokenDetails
